import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import { LBL_DEPARTMENTS, LBL_ALL } from '../../configs/labelConfigs';
import CustomMultiSelect from '../../components/commons/helpers/customMultiSelect';

import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import {titleCase} from '../../utils/changeCase';

import * as types from '../../actions';

class FilterUnavailability extends Component {
    
    constructor(props){
        super(props)
        this.state = { 
            departmentsList:[],
            deptMultiSelList:[],
            selectedDepartments:[],
            resetFilterClicked: 0,
            applyFilterClicked: 0,
        }
    }

    resetFilters = (actionType) => { 
        this.setState({ 
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            selectedDepartments:[],
        }, () => {
            this.loadMultiSelDeptValues();
        }); 
    }

    sendFilterData = () => {
        let foundIssues = 0; 
        if(foundIssues===0) { 
            let filtersSelected = 0; 
            let departments = [];
            if(this.state.selectedDepartments.length){
                filtersSelected = 1; 
                departments = this.state.selectedDepartments
                // if(this.state.deptMultiSelList.length === this.state.selectedDepartments.length){
                //     departments.push('all');
                // }
            }
            let filterData = {departments:departments, filtersSelected:filtersSelected}; 
            this.props.applyFilters(filterData); 
        }
    }

    loadMultiSelDeptValues() {
        let allDept = []; 
        let selectedDepartments = [];
        if(this.state.departmentsList.length > 0) {
           this.state.departmentsList.forEach((item,index) => { 
              allDept.push({value:item.id, label:titleCase(item.name), inputVal:1});
              selectedDepartments.push(item.id) 
           }) 
        }
        this.setState({deptMultiSelList:allDept,selectedDepartments:selectedDepartments},()=>{
                this.sendFilterData()
        });
    }

    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        }); 
        this.setState({selectedDepartments:actUserDept}); 
    }

    componentDidMount() {
        this.props.aflt_departmentsListAction({associated:'1'}); 
    }

    componentDidUpdate (prevProps) { 
        const {depActivity} = this.props; 
        if (depActivity && depActivity !== prevProps.depActivity) {
            let arrTmp = [];
            arrTmp = (depActivity && depActivity.length) ? depActivity.split('~~') : [];
            let actString = arrTmp[0]; 
            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS) { 
                if(this.props.departmentsList.length===0) {
                      this.setState({departmentsList: []}, () => {
                         this.loadMultiSelDeptValues(); 
                      } ); 
                    }
                else {     
                    this.setState({departmentsList: this.props.departmentsList}, () => {
                        this.loadMultiSelDeptValues(); 
                    } );                  
                }
            }
        }

        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(''); 
        }        
    }

    render(){

        const {errorData,status} = this.props;  
        const {deptMultiSelList} = this.state; 

        let paddingTopPix = 250; // TO GIVE SPACE AT BOTTOM
        
        return(
            <React.Fragment>
                <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_DEPARTMENTS}</h4>
                        <div className="form-group multisel_textbox">
                            <div className="form-group select-input skills" >
                            <CustomMultiSelect id={'dept'} data={deptMultiSelList} trimString='yes'  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex:"10" }} tabIndex="10" needSelectAll={true} />
                            </div>
                        </div> 
                    </div>
                </div>

                <div> &nbsp; </div>

                <div style={{paddingTop:paddingTopPix}}></div>
                             
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        errorData:state.afltDepartments.errorData,
        depActivity: state.afltDepartments.activity,
        departmentsList: state.afltDepartments.departmentsList,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_departmentsListAction:aflt_departmentsListAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(FilterUnavailability);  
